<template>
  <div id="header">
    <!--        轮播图-->
    <div class="lunBo">
      <el-carousel height="4.9rem">
        <el-carousel-item v-for="item in imgList" :key="item.id">
          <img :src="item.url" width="100%"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--                nav-->
    <div class="nav">
      <div class="header">
        <div class="logo"></div>
        <div class="nav-tabs" v-for="(item,index)  in  navList" :key="index"  @click="clickChangeColor(index)" :class="{'active':flag==index}">
          <router-link v-if='item.id==0' :to="{name: '首页'}"><span style="color: white">{{item.title}}</span></router-link>
<!--          <a  v-else :href="item.miaoDian"@click="miaoDianUrl(item.miaoDian)" >{{item.title}}</a>-->
          <a  v-else @click="miaoDianUrl(item.miaoDian)" >{{item.title}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      // nav
      navList: [
        {id: 0, title: '网站首页',miaoDian:'/'},
        // {id: 1, title: '公司产业',miaoDian:'#project'},
        {id: 1, title: '项目案例',miaoDian:'#project'},
        {id: 2, title: '关于我们',miaoDian:'#aboutUs'},
        {id: 3, title: '企业动态',miaoDian:'#news'},
      ],
      //轮播图
      imgList: [
        {id: 0, url: require("@/assets/img/lunBo.png")},
        {id: 1, url: require("@/assets/img/lunBo2.png")},
      ],
      flag:0,
    };
  },
  methods:{
    clickChangeColor(index){
      this.flag  =  index;
    },
    miaoDianUrl(id) {  //解决办法: 把a标签替换掉，或者不加href，把要点击的按钮绑定一个点击事件.（刷新不会拼接url 出现空白也）
      // document.querySelector(id).scrollIntoView(true);
      document.querySelector(id).scrollIntoView({   //滚动的动画
                            behavior: "smooth"
                      });
    },
    // miaoDianUrl() {
    //   setTimeout(() => {
    //     // 获取dom
    //     let cateItem = document.querySelectorAll(".active");
    //     let tempTop = cateItem[0].offsetTop - 10;
    //
    //     // 距离细化
    //     let step = tempTop / 50;
    //     // console.log(step);
    //     // 滚动到响应位置  定时器模仿动画
    //     setTimeout(() => {
    //       document.documentElement.scrollTop = tempTop;
    //     }, step);
    //     document.body.scrollTop = tempTop;
    //     // 获取到顶部距离
    //     let distance =
    //         document.documentElement.scrollTop || document.body.scrollTop;
    //     // console.log(distance);
    //     // 获取到锚点位置距离
    //     let newTotal = distance - tempTop;
    //     step = newTotal / 50;
    //     function smoothUp() {
    //       if (distance > tempTop) {
    //         distance -= step;
    //         document.body.scrollTop = tempTop;
    //         document.documentElement.scrollTop = distance;
    //         setTimeout(smoothUp, 10);
    //       } else {
    //         document.body.scrollTop = tempTop;
    //         document.documentElement.scrollTop = tempTop;
    //       }
    //     }
    //     setTimeout(smoothUp(), 10);
    //   }, 0);
    // },
  },
}
</script>

<style scoped>
/* 导航 */
.nav {
  width: 1920px;
  height: 100px;
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  top: 0px;
  z-index: 9999;
}

.header {
  width: 1300px;
  height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
}

.logo {
  /*width: 372px;*/
  /*height: 51px;*/
  width: 532px;
  height: 73px;
  background: url("~@/assets/img/logo.png") no-repeat;
  background-size: 100%;
  margin-right: 200px;
}

/*头部*/
.nav-tabs {
  width: 123px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 17px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #FFFFFF;
}

.active {
  width: 123px;
  height: 50px;
  background: #469DFF;
  border-radius: 10px;
  line-height: 50px;
  text-align: center;
  font-size: 17px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #FFFFFF;
}
.lunBo {
  width: 1920px;
}
.nav-tabs:hover {
  width: 123px;
  height: 50px;
  background: #469DFF;
  border-radius: 10px;
  line-height: 50px;
  text-align: center;
  font-size: 17px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #FFFFFF;
}

</style>